// removed by extract-text-webpack-plugin
module.exports = {"exception":"index__exception__3dQMI","imgBlock":"index__imgBlock__VzkS_","imgEle":"index__imgEle__1zz9C","content":"index__content__-6DJH","desc":"index__desc__2ROXV","actions":"index__actions__1cgdt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Exception/index.less
// module id = 1104
// module chunks = 0